module.exports = __webpack_public_path__ + "static/media/plus.d527ee4e.svg";